import { useMemo, useState } from 'react';
import { SupportCasesTable } from '../components/SupportCasesTable';

export function SupportList() {
  const [query, setQuery] = useState('');
  const [status, setStatus] = useState('open,pending');

  const params = useMemo(() => {
    const p = new URLSearchParams();
    if (query) p.set('q', query);
    if (status) p.set('status', status);
    p.set('limit', '100');
    return p;
  }, [query, status]);

  return (
    <div>
      <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 28, fontWeight: 400 }}>Support</h1>
      <div style={{ display: 'flex', gap: 12, margin: '16px 0 24px' }}>
        <input
          placeholder="Search email, name, subject or case id"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={inputStyle}
        />
        <select value={status} onChange={(e) => setStatus(e.target.value)} style={inputStyle}>
          <option value="open,pending">Active (open + pending)</option>
          <option value="open">Open — needs reply</option>
          <option value="pending">Pending — awaiting customer</option>
          <option value="resolved">Resolved</option>
          <option value="closed">Closed</option>
          <option value="">All</option>
        </select>
      </div>
      <SupportCasesTable params={params} emptyText="No cases match." />
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  padding: '8px 12px',
  border: '1px solid #e5e5e5',
  borderRadius: 6,
  fontSize: 14,
  fontFamily: 'inherit',
  flex: 1,
};
